import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=bbaf2502&scoped=true&"
import script from "./HelpMenu.vue?vue&type=script&lang=js&"
export * from "./HelpMenu.vue?vue&type=script&lang=js&"
import style0 from "./HelpMenu.vue?vue&type=style&index=0&id=bbaf2502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaf2502",
  null
  
)

export default component.exports